import ManageArchiveEditContainer from './ManageArchiveEditContainer';

export default ManageArchiveEditContainer;
